import React from 'react';
import { Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useVoteModalStore } from '../../stores/voteModalStore';

interface ContestVoteButtonProps {
  contestantId: string;
  uniqueCode: string;
  isTopThree?: boolean;
  rank?: number;
}

export const ContestVoteButton: React.FC<ContestVoteButtonProps> = ({ 
  contestantId,
  uniqueCode,
  isTopThree,
  rank
}) => {
  const navigate = useNavigate();
  const setOpen = useVoteModalStore(state => state.setOpen);

  const getButtonStyles = () => {
    if (!isTopThree) return "border-yellow-500 text-yellow-500 hover:bg-yellow-500";
    
    switch (rank) {
      case 1:
        return "border-yellow-300 text-yellow-300 hover:bg-yellow-300";
      case 2:
        return "border-gray-300 text-gray-300 hover:bg-gray-300";
      case 3:
        return "border-amber-600 text-amber-600 hover:bg-amber-600";
      default:
        return "border-yellow-500 text-yellow-500 hover:bg-yellow-500";
    }
  };

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Définir l'ID du candidat pour la modale
    setOpen(true, contestantId);
    
    // Rediriger vers la page du candidat
    navigate(`/${uniqueCode}`);
  };

  return (
    <button
      onClick={handleClick}
      className={`relative z-50 inline-flex items-center px-4 py-2 border ${getButtonStyles()} font-medium rounded-lg hover:text-black transition-colors cursor-pointer`}
    >
      <Heart className="h-4 w-4 mr-2" />
      Voter
    </button>
  );
};
